import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'requiredField',
    standalone: true
})
export class RequiredFieldPipe implements PipeTransform {

	transform(value: string, showed: boolean = true): string {
		return value + (showed ? ' *' : '');
	}
}
